export default (() => {
  const NORMAL_STATE = 'normal',
        LINE_COMMENT_STATE = 'lineComment',
        BLOCK_COMMENT_STATE = 'blockComment',
        QUOTE_STATES = ["'", '"', '`']

  const getQuotedStep = ({ sql, index, state }) => {
    const char = sql[index]

    if(char === '\\' && state !== '`' && index + 1 < sql.length) {
      return { state, next: index + 2 }
    }
    if(char === state && sql[index + 1] === state) {
      return { state, next: index + 2 }
    }
    return { state: char === state ? NORMAL_STATE : state, next: index + 1 }
  }

  const isLineCommentStart = ({ sql, index }) => {
    const char = sql[index]

    if(char === '#') {
      return true
    }
    if(char !== '-' || sql[index + 1] !== '-') {
      return false
    }

    const boundary = sql[index + 2]
    return boundary === undefined || /\s/.test(boundary) || boundary.charCodeAt(0) < 32 || boundary.charCodeAt(0) === 127
  }

  const getCommonStep = ({ sql, index, state }) => {
    const char = sql[index],
          nextChar = sql[index + 1]

    if(state === LINE_COMMENT_STATE) {
      return { state: char === '\n' || char === '\r' ? NORMAL_STATE : LINE_COMMENT_STATE, next: index + 1 }
    }
    if(state === BLOCK_COMMENT_STATE) {
      return char === '*' && nextChar === '/'
        ? { state: NORMAL_STATE, next: index + 2 }
        : { state: BLOCK_COMMENT_STATE, next: index + 1 }
    }
    if(state !== NORMAL_STATE) {
      return getQuotedStep({ sql, index, state })
    }
    if(QUOTE_STATES.includes(char)) {
      return { state: char, next: index + 1 }
    }
    if(char === '/' && nextChar === '*') {
      return { state: BLOCK_COMMENT_STATE, next: index + 2 }
    }
    if(isLineCommentStart({ sql, index })) {
      return { state: LINE_COMMENT_STATE, next: index + (char === '#' ? 1 : 2) }
    }

    return undefined
  }

  const scan = ({ sql = '', getNormalStep }) => {
    const tokens = []
    let index = 0,
        state = NORMAL_STATE

    while(index < sql.length) {
      const step = getCommonStep({ sql, index, state }) || getNormalStep({ sql, index })

      if(step.token) {
        tokens.push(step.token)
      }
      index = step.next
      state = step.state || NORMAL_STATE
    }

    return tokens
  }

  return { scan }
})()
